import { render, staticRenderFns } from "./PhagwaStart.vue?vue&type=template&id=667fe950&"
import script from "./PhagwaStart.vue?vue&type=script&lang=js&"
export * from "./PhagwaStart.vue?vue&type=script&lang=js&"
import style0 from "./PhagwaStart.vue?vue&type=style&index=0&id=667fe950&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports